module.exports = __webpack_public_path__ + "img/flag-cl.f1e61968.svg";